import { colors, Colors, Typography } from '@microfrontends/react-components'
import styled, { css } from 'styled-components'

export const Container = styled.div<{ gap?: number }>`
    display: flex;
    flex-direction: column;
    gap: ${({ gap }) => (gap ? `${gap}px` : '16px')};
`

export const Wrapper = styled.div<{ isMobile?: boolean; notHaveCV?: boolean }>`
    ${({ isMobile }) =>
        !isMobile &&
        css`
            background-color: white;
            border-radius: 6px;
            padding: 24px;
        `}
    ${({ notHaveCV }) =>
        notHaveCV &&
        css`
            background-color: #f0f0f0;
        `}
`

export const Title = styled.div`
    font-weight: 600;
    font-size: 16px;
`

export const TitleWrapper = styled(Typography)`
    display: flex;
    align-items: center;
`

export const TagNew = styled(Typography)`
    background-color: #EBF2FF;
    display: inline-block;
    padding: 2px 4px;
    border-radius: 4px;
    margin-left: 4px;
    color: ${colors.primary[40]};
`
